<template>
  <div class="all">
    <el-header style="z-index: 999;position: fixed;text-align: center;width: 100%;display: flex;background-color:white;;
    color: black;
  ">
      <div class="logo" style="">
        <img src="../assets/img/hylogo.png" alt />
      </div>
      <el-menu
          :default-active="defaultActive"
          class="el-menu-demo"
          mode="horizontal"
          @select="handleSelect"
          :router="router"
          text-color="black"
          active-text-color="#079b51"
      >
        <el-menu-item index="/">首页</el-menu-item>
        <el-submenu>
          <template slot="title"  @click="tosolution">TiU Solution</template>
          <div style="display: flex;">
            <div style="width: 100%">
              <!--                http://123.57.205.53:8090/-->
              <el-menu-item index="/tiyou">TiU Solution</el-menu-item>
              <el-menu-item @click="totiyou">教学提优云平台</el-menu-item>
            </div>
          </div>
        </el-submenu>
        <el-menu-item index="/ai">姿态捕捉</el-menu-item>
        <el-submenu index="3">
          <template slot="title">提供服务</template>
          <div style="display: flex;">
            <div style="width: 50%">
              <el-menu-item index="/szjc">数字化资源</el-menu-item>
              <el-menu-item index="/xqhz2">赛事服务</el-menu-item>
              <el-menu-item index="/xqhz1">校企深度育人</el-menu-item>
            </div>
            <div style="width: 50%">
              <el-menu-item index="/sxs">实训室建设</el-menu-item>
              <el-menu-item index="/xmsb">项目申报</el-menu-item>
            </div>
          </div>
        </el-submenu>
        <el-menu-item index="/about">关于我们</el-menu-item>
      </el-menu>
    </el-header>
    <el-main>
    <div  class="quanp" style="position:relative;" :style="{width:windowWidth,height:windowHeight}" >
<!--      <img style="position: absolute;top: 45%;left: 50%;width: 50px;height: 50px"  src="@/assets/img/quite.png"/>-->
      <div style="width: 100%;height: 100%">
        <video
            muted
            ref="video_index"
            src="@/assets/video/homelogo.mp4"
            preload="auto"
            autoplay="autoplay"
            oncontextmenu="return false"
            controls="controls"
            >
        </video>
      </div>
    </div>
    <div class="first_content">
      <div class="first_content_left">
        <div class="first_content_left_fu">
          <div class="first_content_left_img">
            <img src="@/assets/img/newhome/TiU Solution.png" alt="">
          </div>
          <div class="first_content_left_text">
            <img src="@/assets/img/newhome/tiutext.png" alt="">
          </div>
        </div>

      </div>
      <div class="first_content_right">
        <router-link :to="'tiyou'">
        <div class="first_content_right_img">
          <img src="@/assets/img/newhome/TiU_Logo.png" alt="">
        </div>
        </router-link>
      </div>
    </div>

    <div class="second_content">
      <div v-for="(items,index) in fourData" class="second_content_four" :style="{backgroundImage:items.bgi,height:fourheight}" @click="toLink(items.link)">
          <div class="second_content_four_title">
            <img :src="items.title" alt="">
          </div>
          <div class="second_content_four_fg">

          </div>
          <div class="second_content_four_content">
            <img :src="items.content" alt="">
          </div>
      </div>
    </div>

    <div class="third_content">
      <div class="third_content_left">
        <div class="third_content_left_img">
          <img src="@/assets/img/newhome/thleft.png" alt="">
        </div>
      </div>
      <div class="third_content_right">
        <div class="third_content_right_fu">
          <router-link :to="'szjc'">
            <div class="third_content_right_1">
              <img src="@/assets/img/newhome/thtitle1.png" alt="">
            </div>
            <div class="third_content_right_2">
              <img src="@/assets/img/newhome/thcontent1.png" alt="">
            </div>
          </router-link>
          <router-link :to="'xmsb'">
            <div class="third_content_right_3">
              <img src="@/assets/img/newhome/thtitle2.png" alt="">
            </div>
            <div class="third_content_right_4">
              <img src="@/assets/img/newhome/thcontent2.png" alt="">
            </div>
          </router-link>
        </div>

      </div>
    </div>

    <div class="four_content">
      <div class="four_content_main">
        <div v-for="(items,index) in threeList" class="four_content_main_three">
          <div class="title">
            <div class="title_up">{{items.title}}</div>
            <div class="title_down">
              {{ items.info }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="five_content">
      <div class="footer_text">
        <img src="~@/assets/img/newhome/footer_text.png" alt="">
      </div>
    </div>
    </el-main>
  </div>
</template>

<script>

export default {
  name: "NewHome",
  data(){
    return{
      fourData:[
        {
          title: require("../assets/img/newhome/cjrh.png"),
          bgi:"url(" + require("../assets/img/newhome/bgc1.png") + ")"   ,
          content:require("../assets/img/newhome/content1.png"),
          link:'/xqhz1'
        },
        {
          title: require("../assets/img/newhome/sysjs.png"),
          bgi:"url(" + require("../assets/img/newhome/bgc2.png") + ")"   ,
          content:require("../assets/img/newhome/content2.png"),
          link:'/sxs'
        },
        {
          title: require("../assets/img/newhome/ai.png"),
          bgi:"url(" + require("../assets/img/newhome/bgc3.png") + ")"   ,
          content:require("../assets/img/newhome/content3.png"),
          link:'/ai'
        },
        {
          title: require("../assets/img/newhome/ssfw.png"),
          bgi:"url(" + require("../assets/img/newhome/bgc4.png") + ")"   ,
          content:require("../assets/img/newhome/content4.png"),
          link:'/xqhz2'
        }
      ],
      threeList:[
        {
          title: "1000+",
          info:"数字化教学资源",
        },
        {
          title: "100+",
          info:"服务客户",
        },{
          title: "30+",
          info:"权威认证",
        }
      ],
      realwindowWidth: window.innerWidth,
      windowWidth: "100%",
      windowHeight: window.innerHeight + "px", //实时屏幕高度
      windowWidth2: ((window.innerWidth * 0.7 - 400)  / 2),
      defaultActive: "/",
      router: true,
      isShow: true,
      fourheight:(window.innerWidth/4)/0.9 + 'px',
    }
  },
  methods:{
    toLink(val){
      this.$router.push(val)
    },
    handleSelect(key) {
      this.isShow = this.defaultActive != key;
    },
    totiyou(){
      location.href="http://123.57.205.53:8090/"
    },
    tosolution(){
      alert(11)
      this.$router.push({path:"/tiyou"})
    }
  }

}
</script>

<style lang="scss" scoped>
@import '../assets/css/NewHome.scss';
</style>
<style>
.is-active{
  font-weight: bold;
}
</style>
